import { render, staticRenderFns } from "./TotalPerPage.vue?vue&type=template&id=54f945fe&scoped=true&"
import script from "./TotalPerPage.vue?vue&type=script&lang=ts&"
export * from "./TotalPerPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f945fe",
  null
  
)

export default component.exports